import React from 'react'
import { Text, View } from 'oio-react'
import RichText from 'src/components/utils/RichText'
import { useOrganization } from 'src/graphql/hooks'

const DefaultHomeLayout = () => {
   const { organization } = useOrganization()

   // TODO: The following style/theme props will change alot when we
   // have a real home page (with feed, etc)
   // These props are primarily for demo purposes
   // See PR #616
   let tmpHomeBoxBackgroundColor = organization.theme.highlightColor
   let tmpHomeBoxAlignment = 'flex-end'
   let tmpHomeTextColor = '#fff'
   let tmpHomeAnchorColor = '#fff'

   if (organization.slug === 'fuse') {
      tmpHomeBoxBackgroundColor = '#B2DFDB'
      tmpHomeBoxAlignment = 'center'
      tmpHomeTextColor = '#00695C'
      tmpHomeAnchorColor = '#00695C'
   }

   if (organization.slug === 'banff-pipeline-workshop') {
      tmpHomeBoxBackgroundColor = '#0c233f'
      tmpHomeBoxAlignment = 'center'
      tmpHomeAnchorColor = '#10674b'
   }

   return (
      <View
         width="100%"
         height="100vh"
         backgroundColor="#fff">
         <View
            display="block[a-c] none[d-f]"
            float="left"
            width="100%[a-c] 60%[d-f]"
            paddingTop="75%[a-b] 60%[c]"
            backgroundColor="#000"
            backgroundSize="cover"
            backgroundImage={organization.coverMedia && `url(${organization.coverMedia.file.thumbnailUrlW1600})`}
            backgroundPosition="centre center"
         />
         <View
            display="flex"
            alignItems="center"
            justifyContent={tmpHomeBoxAlignment}
            position="relative"
            width="100%"
            height="100%[d-f]"
            backgroundColor="#333"
            backgroundImage={organization.coverMedia && `url(${organization.coverMedia.file.thumbnailUrlW1600})`}
            backgroundSize="cover"
            backgroundPosition="center center"
            paddingVertical="150px[d-f]"
            paddingHorizontal="40px[d-f]">
            <View
               // TODO: Hide until new Home is real
               // PR #757
               display="none"
               width="100%[a-c] 50%[d] 45%[e-f]"
               minHeight="60vh[a-c]"
               padding="30px[a] 40px[b] 60px[c-f]"
               backgroundColor={tmpHomeBoxBackgroundColor}>
               <Text
                  letterSpacing="-0.25px"
                  size="7[a-d] 9[e-f]"
                  lineHeight="110%"
                  weight="medium"
                  color={tmpHomeTextColor}>
                  {organization.tagline}
               </Text>
               <View
                  display="inline-block"
                  width="42px"
                  height="6px"
                  backgroundColor={tmpHomeAnchorColor}
                  margin="20px 0px"
               />
               <View width="100%">
                  <Text
                     lineHeight="140%[a-b] 140%[c] 140%[d] 150%[e-f]"
                     size="2[a-b] 2.5[c] 2[d] 2.5[e-f]"
                     color={tmpHomeTextColor}
                     weight="light"
                     style={{ opacity: 0.7 }}>
                     <RichText html={organization.description} />
                  </Text>
                  <View
                     display="inline-block"
                     width="10px"
                     height="10px"
                  />
               </View>
            </View>
         </View>
      </View>
   )
}

export default DefaultHomeLayout
